
import { Http, Headers, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import { Injector } from '@angular/core';
import { ModalController, AlertController, PopoverController, Platform, LoadingController, ActionSheetController, NavController, App } from 'ionic-angular';
import { HTTP } from '@ionic-native/http';
import { DomSanitizer } from '../../node_modules/@angular/platform-browser';
import { EthemeProvider } from '../providers/etheme/etheme';
import { GlobalserviceProvider } from '../providers/globalservice/globalservice';
import { TranslateService } from '@ngx-translate/core';
// import { saveAs } from 'file-saver'; 
// 
import { HttpClient } from '@angular/common/http';
import { ErrorPage } from '../pages/error/error';




export abstract class Util {
    // urlserver = 'http://localhost/skilleyd_2/Api/v1.0.1/app/';  
    // urlserver = 'https://dashboard.skilleyd.net/rest/Api/v1.0.1/app/';

    //  
    urlserver = 'https://api.eydlab.com/rest/Api/v1.0.1/app/';       
    //  urlserver = 'https://api.eydlab.com/rest_debug/Api/v1.0.1/app/';      



    // urlupload = 'http://localhost/skilleyd_2/'; 
    // urlupload = 'https://dashboard.skilleyd.net/rest/';
    urlupload = 'https://api.eydlab.com/rest/';
    download_template_up_user = 'https://api.eydlab.com/rest/v1.0.1/xlsx_template/Template_utenti_hr.xlsx';

    keysitecaptcha = '6LeV8WwUAAAAAMCQxKTIagQw_no6Xh71N2XnvZAP';
    secretkeycaptcha = '6LeV8WwUAAAAAIN5_vUYtdd3Lxip8r6fLx5MjMGE';
    urldownloadapp = '';
    etic: any = {
        en: {

            errorinternet: 'Errore connessione internet',
            errorlogin: 'Nome Utente o password errate',

            ERROR_REQUIRED_FIELDS: 'Non hai compilato tutti i campi obbligatori',//1
            ERROR_INSERT_DB: 'Errore inserimento nel database',//2
            ERROR_ID_NOT_VALID: 'Id non valido',//3
            ERROR_ACTION_PARAM_NOT_VALID: 'Parametro non valido',//4
            ERROR_DELETE_DB: 'Errore eliminazione nel database',//5
            ERROR_UPDATE_DB: 'Errore aggiornamento nel database',//6
            ERROR_DUPLICATE_ENTRY: 'Errore chiave duplicata',//7
            ERROR_SESSION_NOT_VALID: 'Errore di sessione',//8
            ERROR_PASSORD_DONT_MATCH: 'La password non è uguale',//9
            ERROR_EMAIL_NOT_SENT: 'Errore invio dell\'email',//10
            ERROR_PURCHASE: 'Errore nell\'acquisto',//11
            ERROR_SIZE_LIMIT_REQUEST: 'Errore richiesta troppo grande',//12
            ERROR_DELETE_DB_REFERENCE: 'Errore eliminazione nel database',//13
            ERROR_INVALID_USERNAME_PASSWORD: 'Nome utente o password errate',//14
            ERROR_INVALID_SESSION: 'Errore di sessione',//15
            ERROR_NOT_AUTHORIZED: 'Non hai nessuna autorizzazione',//16
            ERROR_USER_DISABLED: 'Utente disabilitato',//17
            ERROR_PAYPAL: 'Errore Paypal',//18
            ERROR_UPLOAD_FILE: 'Errore Upload file',//18


            // const ERROR_REQUIRED_FIELDS = 1;
            // const ERROR_INSERT_DB = 2;
            // const ERROR_ID_NOT_VALID = 3;
            // const ERROR_ACTION_PARAM_NOT_VALID = 4;
            // const ERROR_DELETE_DB = 5;
            // const ERROR_UPDATE_DB = 6;
            // const ERROR_DUPLICATE_ENTRY = 7;
            // const ERROR_SESSION_NOT_VALID = 8;
            // const ERROR_PASSORD_DONT_MATCH = 9;
            // const ERROR_EMAIL_NOT_SENT = 10;
            // const ERROR_PURCHASE = 11;
            // const ERROR_SIZE_LIMIT_REQUEST = 12;
            // const ERROR_DELETE_DB_REFERENCE = 13;
            // const ERROR_INVALID_USERNAME_PASSWORD = 14;
            // const ERROR_INVALID_SESSION = 15;
            // const ERROR_NOT_AUTHORIZED = 16;
            // const ERROR_USER_DISABLED = 17;
            // const ERROR_PAYPAL = 18;
        }
    };

    httpobj: any;
    mylatitude: any;
    mylongitude: any;
    iframepecserver: any;
    public storage: Storage;
    public http: any;
    public modalCtrl: ModalController;
    public alertCtrl: AlertController;
    public popoverCtrl: PopoverController;
    public plt: Platform;
    public loadingCtrl: LoadingController = null;
    public sanitizer: DomSanitizer;
    public actionsheetCtrl: ActionSheetController;
    public etheme: EthemeProvider;
    public gs: GlobalserviceProvider;
    public translate: TranslateService;
    private httpx: HttpClient;
    // private navCtrl: NavController;
    // public filesave: saveAs;
    public app: App;
    constructor(injector: Injector, loading: LoadingController) {
        this.plt = injector.get(Platform);
        this.loadingCtrl = loading;
        if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
            this.http = injector.get(HTTP);
        else
            this.http = injector.get(Http);

        this.storage = injector.get(Storage);
        this.modalCtrl = injector.get(ModalController);
        this.alertCtrl = injector.get(AlertController);
        this.popoverCtrl = injector.get(PopoverController);
        this.sanitizer = injector.get(DomSanitizer);
        this.actionsheetCtrl = injector.get(ActionSheetController);
        this.etheme = injector.get(EthemeProvider);
        this.gs = injector.get(GlobalserviceProvider);
        this.httpx = injector.get(HttpClient);
        this.app = injector.get(App);
        // this.navCtrl = injector.get(NavController);
        // this.filesave = injector.get(saveAs);
    }
    nav_error(){
        this.storage.get('language').then((lan) => {
          var language = lan;
          this.storage.remove('user').then(() => {
            // this.storage.clear();
            this.storage.set('language', language).then((lan) => {
              this.app.getActiveNav().setRoot(ErrorPage); 
              // window.location.reload();
            })
          });
        })
        
      }

    presentPopover_iniziale(myEvent, PopoverPage, testo, num?, enableBackdropDismiss?) {

        return new Promise((resolve, reject) => {
            var postop = (this.plt.height() / 2) - 200;
            let popover: any;
            if (enableBackdropDismiss != null && enableBackdropDismiss != undefined)
                popover = this.popoverCtrl.create(PopoverPage, { testo: testo, num: num }, { enableBackdropDismiss: enableBackdropDismiss, cssClass: this.etheme.theme_selected + ' init_popup' });
            else
                popover = this.popoverCtrl.create(PopoverPage, { testo: testo, num: num }, { cssClass: this.etheme.theme_selected + ' init_popup' });
            let ev = {
                target: {
                    getBoundingClientRect: () => {
                        return {
                            top: postop
                        };
                    }
                }
            };
            popover.present({
                ev: ev
            });
            /*popover.present({
                ev: myEvent
            });*/
            popover.onDidDismiss((data) => {
                resolve(data);
            })
        })

    }


    presentPopover(myEvent, PopoverPage, testo, num?, enableBackdropDismiss?) {

        return new Promise((resolve, reject) => {
            var postop = (this.plt.height() / 2) - 200;
            let popover: any;
            if (enableBackdropDismiss != null && enableBackdropDismiss != undefined)
                popover = this.popoverCtrl.create(PopoverPage, { testo: testo, num: num }, { enableBackdropDismiss: enableBackdropDismiss, cssClass: this.etheme.theme_selected });
            else
                popover = this.popoverCtrl.create(PopoverPage, { testo: testo, num: num }, { cssClass: this.etheme.theme_selected });
            let ev = {
                target: {
                    getBoundingClientRect: () => {
                        return {
                            top: postop
                        };
                    }
                }
            };
            popover.present({
                ev: ev
            });
            /*popover.present({
                ev: myEvent
            });*/
            popover.onDidDismiss((data) => {
                resolve(data);
            })
        })

    }
    /*PostRequest(link, params, http) {
        return new Promise((resolve, reject) => {
            var headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            http.post(link, params, { headers: headers })
                .subscribe(data => {
                    if (data['status'] == 200) {
                        var returned = data['_body'];
                        resolve(JSON.parse(returned)); 
                    }
                    else
                        reject('Errore server' + data['_body']);

                }, error => {
                    reject('Errore server');
                });
        });

    }*/

    private manageResponseError(response: any, showAlertError: boolean) {
        this.translate.get('errori').subscribe((v) => {
            // this.navCtrl.push(ErrorPage, {}, { animate: false }); 
            
            if (showAlertError) {
                console.log('errore su manageerror:', response);
                if (response.errors != null) {
                    // console.log('1', response);
                    this.showBasicAlert(v['ERROR'], response.errors);
                }
                else if (response.error != null) {
                    // console.log('2', response);
                    try {
                        // var eobjx = JSON.parse(response.error);

                        var e = response.error;
                        try {
                            var eobj = JSON.parse(e);
                        }
                        catch (err) {
                            this.showBasicAlert(v['ERROR'], this.etic.en.errorinternet);
                            return;
                        }
                        // console.log(e);
                        // this.showBasicAlert('Errore', JSON.parse(e).errors);

                        var paramserr = JSON.parse(e).error_vars;
                        var errcode = parseInt(JSON.parse(e).errors);
                        // console.log(errcode);
                        var errstr = v[errcode];

                        if (paramserr) {
                            for (var i = 0; i < paramserr.length; i++) {
                                errstr = v[errcode].replace('%s', paramserr[i]);
                            }
                        }
                        this.showBasicAlert(v['ERROR'], errstr);
                    }
                    catch (err) {
                        this.showBasicAlert(v['ERROR'], this.etic.en.errorinternet);
                        return;
                    }

                }
                else if (response != null) {
                    // console.log('3', response);
                    var e = response['_body'];
                    try {
                        var eobj = JSON.parse(e);
                    }
                    catch (err) {
                        this.showBasicAlert(v['ERROR'], this.etic.en.errorinternet);
                        return;
                    }
                    // console.log(e);
                    // this.showBasicAlert('Errore', JSON.parse(e).errors);

                    var paramserr = JSON.parse(e).error_vars;
                    var errcode = parseInt(JSON.parse(e).errors);
                    // console.log(errcode);
                    if(errcode == 54){
                        this.nav_error();
                        return;
                    }
                    var errstr = v[errcode];

                    if (paramserr) {
                        for (var i = 0; i < paramserr.length; i++) {
                            errstr = v[errcode].replace('%s', paramserr[i]);
                        }
                    }
                    this.showBasicAlert(v['ERROR'], errstr);



                }
                else {
                    this.showBasicAlert(v['ERROR'], this.etic.en.errorinternet);
                }
            }

        })

    }

    private manageResponse(response: string, error: string, loading: any, showAlertError: boolean, resolve: any, reject: any) {

        if (loading != null) {
            loading.dismiss();
        }

        if (response != null) {
            // console.log(response);
            try {
                var responseObj = JSON.parse('' + response + '');
                if (responseObj.response == 0) {
                    resolve(responseObj['data']);
                }

                else {
                    // console.log('1', responseObj);
                    this.manageResponseError(responseObj, showAlertError);
                    reject(responseObj);
                }
            }
            catch (e) {
                // console.log('2', e);
                this.manageResponseError(e, showAlertError);
                reject(e);
            }
        } else {
            // console.log('3', error);
            this.manageResponseError(error, showAlertError);
            reject(error);
        }

    }

    GetRequest(service, id, showLoading: boolean = true, showAlertError: boolean = true) {
        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: ''
            });
            loading.present();
        }

        if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    // console.log('token:', user.token);
                    this.http.setHeader('Language', this.translate.getDefaultLang());
                    this.http.setHeader('template', this.etheme.theme_selected);
                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.token);
                    this.http.setDataSerializer('json');
                    this.http.get(this.urlserver + service + "/" + id, {}, {})
                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            // console.log(JSON.stringify(error));
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else
            return new Promise((resolve, reject) => {
                let headers = new Headers();


                headers.append("Content-Type", "application/json");
                headers.append('Language', this.translate.getDefaultLang());
                headers.append('template', this.etheme.theme_selected);
                this.storage.get('user').then(user => {
                    // console.log('token:', user);
                    if (user != null && user.token != undefined) {
                        headers.append('Authorization', 'Bearer ' + user.token);
                    }

                    this.http.get(this.urlserver + service + "/" + id, { headers: headers })
                        .subscribe(res => {

                            this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                        },
                            error => {
                                this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                            });
                });
            });
    }

    PostRequest(service, id, params, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: ''
            });
            loading.present();
        }

        if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    //this.http.setHeader('Accept', 'application/json');
                    this.http.setHeader('Language', this.translate.getDefaultLang());
                    this.http.setHeader('template', this.etheme.theme_selected);
                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.token);

                    this.http.setDataSerializer('json');
                    this.http.post(this.urlserver + service + "/" + id, params, {})

                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            console.log('POST error:', error);
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else
            return new Promise((resolve, reject) => {
                let headers = new Headers();

                headers.append("Content-Type", "application/json");
                headers.append('Language', this.translate.getDefaultLang());
                headers.append('template', this.etheme.theme_selected);
                // headers.append('Authorization', 'Bearer ' + 'asdf');
                this.storage.get('user').then(user => {

                    if (user != null && user.token != undefined) {
                        headers.append('Authorization', 'Bearer ' + user.token);
                    }
                    this.http.post(this.urlserver + service + "/" + id, params, { headers: headers })
                        .subscribe(res => {
                            this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                        },
                            error => {
                                this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                            });

                })
            });
    }

    PutRequest(service, id, params, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: ''
            });
            loading.present();
        }

        if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    //this.http.setHeader('Accept', 'application/json');
                    this.http.setHeader('Language', this.translate.getDefaultLang());
                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.token);

                    this.http.setDataSerializer('json');
                    this.http.put(this.urlserver + service + "/" + id, params, {})

                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else
            return new Promise((resolve, reject) => {
                let headers = new Headers();
                headers.append('Language', this.translate.getDefaultLang());
                headers.append("Content-Type", "application/json");
                this.storage.get('user').then(user => {
                    // console.log(user);
                    if (user != null && user.token != undefined) {
                        headers.append('Authorization', 'Bearer ' + user.token);
                    }
                    this.http.put(this.urlserver + service + "/" + id, params, { headers: headers })
                        .subscribe(res => {
                            this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                        },
                            error => {
                                this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                            });

                })
            });
    }
    PutRequest_old(service, id, params, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: ''
            });
            loading.present();
        }

        /*if (this.plt.is('ios') || this.plt.is('android'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    //this.http.setHeader('Accept', 'application/json');

                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.user.token);
                    this.http.setDataSerializer('json');
                    this.http.put(this.urlserver + service + "/" + id, params, {})
                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else*/
        return new Promise((resolve, reject) => {
            let headers = new Headers();
            headers.append("Content-Type", "application/json");
            this.storage.get('user').then(user => {

                if (user != null && user.user.token != undefined) {
                    headers.append('Authorization', 'Bearer ' + user.user.token);
                }
                this.http.put(this.urlserver + service + "/" + id, params, { headers: headers })
                    .subscribe(res => {
                        this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                    },
                        error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
            });
        });
    }




    DeleteRequest(service, id, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: ''
            });
            loading.present();
        }


        /*if (this.plt.is('ios') || this.plt.is('android'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    //this.http.setHeader('Accept', 'application/json');

                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.user.token);
                    this.http.setDataSerializer('json');
                    this.http.delete(this.urlserver + service + "/" + id, {}, {})
                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else*/
        // return new Promise((resolve, reject) => {
        //     let headers = new Headers();
        //     headers.append("Content-Type", "application/json");
        //     this.storage.get('user').then(user => {

        //         if (user != null && user.user.token != undefined) {
        //             headers.append('Authorization', 'Bearer ' + user.user.token);
        //         }
        //         this.http.delete(this.urlserver + service + "/" + id, { headers: headers })
        //             .subscribe(res => {
        //                 this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
        //             },
        //                 error => {
        //                     this.manageResponse(null, error, loading, showAlertError, resolve, reject);
        //                 });
        //     });
        // });
    }


    GetRequestwithcredential(service, id, showLoading: boolean = true, showAlertError: boolean = true) {
        return new Promise((resolve, reject) => {
            this.httpx.get(this.urlserver + service, { withCredentials: true }).subscribe((r) => {
                // this.httpx.get("https://api.eydlab.com/rest_debug/Api/v1.0.1/app/readSession",{  withCredentials: true }).subscribe((r)=>{

                resolve(r);
            }, (err) => {
                reject(err);
            });
        })
        /*
                var loading = null;
                if (showLoading && this.loadingCtrl != null) {
                    loading = this.loadingCtrl.create({
                        content: ''
                    });
                    loading.present();
                }
        
                if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
                    return new Promise((resolve, reject) => {
                        this.storage.get('user').then(user => {
                            // console.log('tokexxxxxxn:', user.token);
                            // this.http.setHeader('Language', this.translate.getDefaultLang());
                            // this.http.setHeader('template', this.etheme.theme_selected);
                            if (user != null && user != undefined && user != '')
                                this.http.setHeader('Authorization', 'Bearer ' + user.token);
                            this.http.setDataSerializer('json');
                            this.http.get(this.urlserver + service , {}, {})
                                .then(data => {
                                    this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                                })
                                .catch(error => {
                                    // console.log(JSON.stringify(error));
                                    this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                                });
                        });
                    });
                else
                    return new Promise((resolve, reject) => {
                        let headers = new Headers();
        
        
                        headers.append("Content-Type", "application/json");
                        // headers.append("Content-Type", "application/x-www-form-urlencoded");
                        // headers.append('Language', this.translate.getDefaultLang());
                        // headers.append('template', this.etheme.theme_selected);
                        // headers.append('withCredentials', 'true');
                        this.storage.get('user').then(user => {
                            // console.log('token2222:', user);
                            if (user != null && user.token != undefined) {
                                headers.append('Authorization', 'Bearer ' + user.token);
                            }
                            let options = new RequestOptions({ headers: headers, withCredentials: true });
                            this.http.get(this.urlserver + service , options)
                                .subscribe(res => {
        
                                    this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                                },
                                    error => {
                                        this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                                    });
                        });
                    });
                    */
    }

    showBasicAlert(title, subtitle) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: [{
                text: 'OK',
                role: 'cancel'
            }],
            cssClass: this.etheme.theme_selected
        });
        alert.present();
    }

    presentAlertPrompt() {
        let alert = this.alertCtrl.create({
            title: 'Login',
            inputs: [
                {
                    name: 'username',
                    placeholder: 'Username'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: data => {
                        // console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Login',
                    handler: data => {
                        // console.log('aaa');
                    }
                }
            ]
        });
        alert.present();
    }


    PostRequest_(link, params, loadingCtrl, storage, platform) {
        return new Promise((resolve, reject) => {
            var http: any = this.http;
            storage.get('mycity').then((mycity) => {
                // console.log(mycity);
                if (mycity != null && mycity.hasOwnProperty('nome_IT')) {
                    link = link + '&city=' + mycity.nome_IT;
                    params.city = mycity.nome_IT;
                }
                let loading = loadingCtrl.create({
                    content: ''
                });
                loading.present();

                if (platform.is('ios') || platform.is('android')) {
                    http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                    http.setHeader('Accept', 'application/json');
                    // console.log('sono qui 0');
                    http.post(link, params, {})
                        .then(data => {
                            // console.log('******');
                            // console.log(data);
                            // console.log('******122222');
                            if (data['status'] == 200) {
                                var returned = data['data'];
                                try {

                                    resolve(JSON.parse(returned));
                                } catch (e) {
                                    reject('Errore JSON');
                                }
                                if (loading != null) loading.dismiss();
                            }
                            /*else if(data['status'] == 401){
    
                            }*/
                            else {
                                reject('Non sei connesso a Internet');
                                // console.log('sono qui 1');
                                if (loading != null) loading.dismiss();
                            }


                        }, error => {
                            // console.log('sono qui 2');
                            reject('Non sei connesso a Internet');
                            if (loading != null) loading.dismiss();
                        });
                }
                else {
                    let _params = new URLSearchParams();
                    for (let key in params) {
                        _params.set(key, params[key])
                    }
                    var headers = new Headers();
                    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                    headers.append('Accept', 'application/json');
                    http.post(link, _params.toString(), { headers: headers })
                        .subscribe(data => {
                            // console.log(data);
                            if (data['status'] == 200) {
                                var returned = data['_body'];
                                try {
                                    resolve(JSON.parse(returned));
                                } catch (e) {
                                    reject('Errore JSON');
                                }
                                if (loading != null) loading.dismiss();
                            }
                            else {
                                reject('Errore server 3' + data['_body']);
                                if (loading != null) loading.dismiss();
                            }


                        }, error => {
                            reject('Errore server 4 : ' + link + ' header: ' + JSON.stringify(headers) + ' params: ' + _params.toString());
                            if (loading != null) loading.dismiss();
                        });
                }

            });
        });
        //});

    }


    openModal(ModalPage, params) {
        return new Promise((resolve, reject) => {
            let profileModal = this.modalCtrl.create(ModalPage, params, { cssClass: this.etheme.theme_selected });
            profileModal.onDidDismiss(data => {
                resolve(data);
            });
            profileModal.present();
        });
    }

    distance(lat1, lon1, lat2, lon2) {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        //if (unit=="K") { dist = dist * 1.609344 } km
        //if (unit=="N") { dist = dist * 0.8684 }miglia nautiche
        dist = dist * 1.609344
        return dist;
    }
    arrotondaNumero(numero, nDecimali) {
        // arrotondo il numero con le cifre decimali indicate
        var numero_arrotondato = Math.round(numero * Math.pow(10, nDecimali)) / Math.pow(10, nDecimali);
        // ritorno come risultato il numero arrotondato
        return numero_arrotondato;
    }
    showAlert(title, subtitle, alertCtrl) {
        let alert = alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: ['OK']
        });
        alert.present();
    }
    open_in_app_browser(pdfpath, platform?, iab?) {

        /*if (platform.is('ios') || platform.is('android')) {

            console.log(pdfpath);
            if (platform.is('android')) {
                let iabobj = iab.create(pdfpath, '_blank', "location=yes");
                iabobj.show();
            }
            else {
                let iabobj = iab.create(pdfpath, '_blank', "location=yes,closebuttoncaption=Chiudi,enableViewportScale=yes");
                iabobj.show();
            }

        }
        else*/
        window.open(pdfpath, '_blank');

    }
    clone(obj) {
        let copy = (JSON.parse(JSON.stringify(obj)));
        return copy;
    }

    presentActionSheet(title, buttons_) {
        return new Promise((resolve, reject) => {

            var bu = [];
            for (let i = 0; i < buttons_.length; i++) {
                bu.push({
                    text: buttons_[i].text,
                    icon: buttons_[i].icon,
                    handler: () => {
                        resolve(i);
                    }
                })
            }

            bu.push({
                text: 'Annulla',
                role: 'cancel',
                handler: () => {
                    resolve('annulla');
                    // console.log('Cancel clicked');
                }
            });


            const actionSheet = this.actionsheetCtrl.create({
                title: title,
                buttons: bu
            });
            actionSheet.present();
        })

    }

    svuota_cachex(mj_id, mq_id) {
        this.storage.remove('microquest_risposte_' + mq_id + '_' + this.gs.userx.id);
        this.storage.remove('microquest_domande_' + mq_id + '_' + this.gs.userx.id);
        this.storage.remove('microquest_tempo_' + mq_id + '_' + this.gs.userx.id);
        this.storage.remove('microquest_' + mq_id + '_' + this.gs.userx.id);
        this.storage.get('mq_saved_' + mj_id + '_' + this.gs.userx.id).then((mq_saved) => {
            if (mq_saved.indexOf(mq_id) != -1) {
                mq_saved.splice(mq_saved.indexOf(mq_id), 1);
                this.storage.set('mq_saved_' + mj_id + '_' + this.gs.userx.id, mq_saved);
            }
        })
    }

    svuota_cache_all_mj(mj_id) {
        // this.storage.remove('microquest_risposte_' + mq_id);
        // this.storage.remove('microquest_domande_' + mq_id);
        // this.storage.remove('microquest_tempo_' + mq_id);
        // this.storage.remove('microquest_' + mq_id);
        this.storage.get('mq_saved_' + mj_id + '_' + this.gs.userx.id).then((mq_saved) => {
            //   if (mq_saved.indexOf(mq_id) != -1) {
            // mq_saved.splice(mq_saved.indexOf(mq_id), 1);
            if (mq_saved != null) {
                mq_saved.forEach((mq_id) => {
                    this.storage.remove('microquest_risposte_' + mq_id + '_' + this.gs.userx.id);
                    this.storage.remove('microquest_domande_' + mq_id + '_' + this.gs.userx.id);
                    this.storage.remove('microquest_tempo_' + mq_id + '_' + this.gs.userx.id);
                    this.storage.remove('microquest_' + mq_id + '_' + this.gs.userx.id);
                })
                this.storage.set('mq_saved_' + mj_id + '_' + this.gs.userx.id, []);
            }
            //   }
        })
    }

    // downloadFile(url) {
    //     this.filesave(url);
    // }
}



// WEBPACK FOOTER //
// ./src/app/util.ts